/**
 * 判斷是否已經滾動到頁面底部
 */

import { useWindowSize } from '@vueuse/core';

export function useScrollArrivedBottom() {
  const { height } = useWindowSize();
  const { y } = useScrollValue();
  const arrived = ref<boolean>(false);

  watch(
    y,
    () => {
      if (import.meta.client) {
        const scrollHeight = document.documentElement.scrollHeight;

        if (scrollHeight <= height.value) {
          arrived.value = false;
          return;
        }

        if (scrollHeight - height.value <= Math.ceil(y.value)) {
          arrived.value = true;
        } else {
          arrived.value = false;
        }
      }
    },
    { immediate: true }
  );

  return { arrived };
}
